import edit from './edit'
import send from './send'
import guest from './guest'
import chipIn from './chip_in'
import CampaignPage from 'components/pages/campaign'
import CampaignNotFound from 'components/pages/campaign_not_found'
import CountryBlocked from 'components/common/country_blocked'
import CrowdFundingDetailsPage from 'components/pages/crowdfunding/crowdfunding_details'
import { getCampaignSelector } from 'redux/selectors/campaign'
import createRoute from './create'
import createCrowdfundingRoute from './create_crowdfunding'
import hubRoute from './hub'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export default (store, history, path) => ({
  indexRoute: hubRoute(store, history),
  path,
  childRoutes: [
    createRoute(store),
    createCrowdfundingRoute(store),
    {
      path: ':campaignId',
      getComponent(nextState, callback) {
        if (!store.getState().user_config) {
          return callback(null, CountryBlocked)
        }
        let campaign = getCampaignSelector(store.getState(), {
          campaignId: nextState.params.campaignId,
        })
        if (!campaign) {
          return callback(null, CampaignNotFound)
        }

        // return crowdfunding detail component
        if (campaign.campaign_type === CROWD_FUNDING) {
          return callback(null, CrowdFundingDetailsPage)
        }
        return callback(null, CampaignPage)
      },
      childRoutes: [
        edit(store, history),
        send(store, history),
        guest(store, history),
        chipIn(store, history),
      ],
    },
  ],
})
